import styled from '@emotion/styled';
import { H3, Text } from 'ds/components/typography';

export const CurrentBulletinMarker = styled.div`
  width: 12px;
  height: 12px;
  border: solid 3px ${props => props.theme.colors.insights.prices};
  background-color: ${props => props.theme.colors.neutrals.white};
  border-radius: ${({ theme }) => theme.borderRadius.round};
`;

export const PriceEstimationTitle = styled(H3)`
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

export const Wrapper = styled.div`
  padding: ${({ theme }) => theme.spacing(3)};
  ${({ theme }) => theme.isRTL ? '' : `border-bottom: solid 1px ${theme.colors.neutrals.grey8};`}
  ${({ theme }) => theme.media.showAt({ to: 1 }) `
    padding: ${theme.spacing(3)} ${theme.spacing(2)};
  `}
`;

export const TipWrapper = styled(Text)`
  border-radius: ${({ theme }) => theme.borderRadius.small};
  background-color: ${({ theme }) => theme.colors.neutrals.grey10};
  color: #818181; /* might need to be updated later */
  ${({ theme }) => theme.media.showAt({ to: 2 })`padding: 12px;`}
  ${({ theme }) => theme.media.showAt({ from: 3 })`padding: 16px;`}
  display: flex;
  margin-top: ${({ theme }) => theme.spacing(6)};
  svg {
    margin-${({ theme }) => theme.isRTL ? 'left' : 'right'}: ${({ theme }) => theme.spacing(1)};
    flex-shrink: 0;
  }
  > div > div:first-of-type {
    color: ${({ theme }) => theme.colors.neutrals.grey1};
  }
`;

export const TooltipWrapper = styled.div`
  display: inline-block;
  height: 16px;
`;
